import { gql } from "__generated__/gql";
import { useApolloClient } from "@apollo/client";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";

const PJKRouteSelect = ({ value, onChange }: Omit<SelectProps<string, false>, "fetchOptions">) => {

	const client = useApolloClient();

	const onFetchOptions = async() => {

		const result = await client.query({
			query: query,
		});

		return {
			options: result.data.pjkRoutes,
			totalResults: result.data.pjkRoutes.length,
		};
	};

	return (
		<Select
			fetchOptions={onFetchOptions}
			value={value}
			onChange={onChange}
			clearable={false} />
	);
};

const query = gql(`#graphql
	query pjkRoutes_select {
		pjkRoutes
	}
`);

export default PJKRouteSelect;
